var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesPromotion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38202"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21569",
    d: "M22 43.943V43.5c0-1.995-3.009-3.5-7-3.5s-7 1.505-7 3.5v3.182c0 1.662 2.088 2.982 5.091 3.377v.441c0 1.995 3.009 3.5 7 3.5s7-1.505 7-3.5v-3.182c0-1.646-2.022-2.968-5.091-3.375zm3.818 3.375c0 1.052-2.449 2.227-5.727 2.227-.3 0-.591-.01-.881-.029 1.716-.625 2.79-1.641 2.79-2.834v-1.453c2.376.354 3.818 1.315 3.818 2.089zM13.091 48.77v-1.893a14.937 14.937 0 0 0 3.818 0v1.893a13.161 13.161 0 0 1-3.818 0zm7.636-3.207v1.119c0 .667-.987 1.384-2.545 1.819v-1.859a7.486 7.486 0 0 0 2.545-1.079zM15 41.273c3.278 0 5.727 1.176 5.727 2.227S18.278 45.727 15 45.727 9.273 44.552 9.273 43.5s2.449-2.227 5.727-2.227zm-5.727 5.409v-1.119a7.486 7.486 0 0 0 2.545 1.079V48.5c-1.558-.434-2.545-1.151-2.545-1.818zm5.091 3.818v-.332a14.892 14.892 0 0 0 1.542-.014 9.7 9.7 0 0 0 1 .3v1.866c-1.555-.436-2.542-1.153-2.542-1.82zm3.818 2.088v-1.9a14.277 14.277 0 0 0 1.909.127A14.616 14.616 0 0 0 22 50.7v1.892a13.161 13.161 0 0 1-3.818 0zm5.091-.269V50.46a7.486 7.486 0 0 0 2.545-1.079V50.5c0 .667-.987 1.384-2.545 1.819z",
    transform: "translate(-5.546 -34.999)",
    style: {
      stroke: "currentColor",
      strokeWidth: ".5px",
      fill: "currentColor"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesPromotion);
export default __webpack_public_path__ + "static/media/sales-promotion.11d974c81acfdb4fe4961bdd989d5fe2.svg";
export { ForwardRef as ReactComponent };